import { Routes } from '@angular/router';
import { authGuard, sesionGuard } from './modules/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./modules/inicio/inicio.component').then((m) => m.InicioComponent),
      },
    ],
  },
  // Unilogin manda aquí al trabajador (/enc/0/0/N35GR3; /enc/0/0/demo usa datos de prueba).
  // Sólo exige sesión: el módulo (NOM035ST) lo valida la API, ver sesionGuard.
  {
    path: 'enc/:clave/:subclave/:encuesta',
    canActivate: [sesionGuard],
    loadComponent: () =>
      import('./modules/encuesta/encuesta.component').then((m) => m.EncuestaComponent),
  },
  { path: '**', redirectTo: '' },
];
